import mediabox from 'mediabox'

const initMediaBox = () => {
  mediabox('.mediabox', { enablejsapi: 1 })
}

export default initMediaBox
